import React from 'react';
import Box from '@mui/material/Box';

import PropTypes from 'prop-types';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';

const CancelGroupOrderCTA = ({ handleOnClick }) => {
  return (
    <Box marginBottom={4}>
      <SecondaryCta
        handleClick={handleOnClick}
        label="Cancel Group Order"
        ownState={getOwnCartDrawerState()}
        sx={{ marginTop: '8px', marginBottom: '16px' }}
        dataTestId="cancel-group-order-button"
      />
    </Box>
  );
};

CancelGroupOrderCTA.propTypes = {
  handleOnClick: PropTypes.func.isRequired
};

export default CancelGroupOrderCTA;
